module.exports = __webpack_public_path__ + "static/enbw-logo-6f4d9515fb28f66e9b0bf3293a14204b.jpg";